import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 21.209 21.209"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#1d1d1d",
      d: "M4.748 21.209H.35V7.049h4.4ZM2.547 5.117a2.559 2.559 0 1 1 2.546-2.571 2.568 2.568 0 0 1-2.546 2.571ZM21.2 21.209h-4.383v-6.893c0-1.643-.033-3.75-2.286-3.75-2.286 0-2.637 1.785-2.637 3.631v7.012H7.5V7.049h4.217V8.98h.062a4.62 4.62 0 0 1 4.16-2.287c4.45 0 5.268 2.931 5.268 6.737v7.779Z",
      "data-name": "Icon fa-brands-linkedin-in"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "share-linkedin"}) } }